import { createGenericApiSlice } from "../../../Api/Factory/genericApiFactory";
import { TagTypes } from "../../../Api/Types/tagTypes";
import { Invoice } from "../Types/invoicesTypes";

export const invoicesApi = createGenericApiSlice<Invoice>({
  reducerPath: "invoicesApi",
  tag: TagTypes.Invoice,
  endpoint: "invoices",
});

export const {
  useGetAllQuery: useGetInvoicesQuery,
  useGetByIdQuery: useGetInvoiceByIdQuery,
  useCreateMutation: useCreateInvoiceMutation,
  useUpdateMutation: useUpdateInvoiceMutation,
  useDeleteMutation: useDeleteInvoiceMutation,
} = invoicesApi;
